import "./FoodBadges.css";

function FoodBadges({ food }) {
  return (
    <div className="food-badges">

      <span
        className={`food-type ${
          food.foodType === "Veg"
            ? "veg"
            : food.foodType === "Egg"
            ? "egg"
            : food.foodType === "Vegan"
            ? "vegan"
            : "nonveg"
        }`}
      >
        {food.foodType}
      </span>

      {food.isBestSeller && (
        <span className="badge bestseller">
          Bestseller
        </span>
      )}

      {food.availableToday && (
        <span className="badge special">
          Today
        </span>
      )}

    </div>
  );
}

export default FoodBadges;